import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import useQuestionnaires from '../../../hooks/queries/useQuestionnaires';
import { useAppSelector } from '../../../redux/hooks';

import FamilyHistoryComponent from './component';

import { HISTORY_TYPE } from '../../../constants';

const FamilyHistory: React.FC = () => {
  const navigate = useNavigate();
  const [isQuestionnaireComplete, setIsQuestionnaireComplete] =
    useState<boolean>(true);

  const { id: patientId } =
    useAppSelector((state) => state.auth.currentUser) || {};

  const { questionnaires } = useQuestionnaires({
    type: HISTORY_TYPE.FAMILY,
    patientId,
  });

  const toggleQuestionnaireCompletion = () =>
    setIsQuestionnaireComplete((prevState) => !prevState);

  const navigateToTasks = () => navigate('/tasks');

  return (
    <FamilyHistoryComponent
      isQuestionnaireComplete={isQuestionnaireComplete}
      questionnaires={questionnaires}
      toggleQuestionnaireCompletion={toggleQuestionnaireCompletion}
      navigateToTasks={navigateToTasks}
    />
  );
};

export default FamilyHistory;
